import getGlobals from './globals';

const getGlobal = (rootState, globalId) =>
  getGlobals(rootState).find((global) => global.id === globalId) || null;

export default getGlobal;
